import Vue from 'vue'
import axios from 'axios'
const baseUrl = `/wp-json/wp/v2`


if (document.getElementById('vue-news')) {
  const categoryToExclude = document.getElementById('vue-news').dataset.category
  new Vue({
    delimiters: ["[[", "]]"],
    async asyncData({ params, $http }) {
      const news = await $http.$get(`${baseUrl}/posts`)
      return { news }
    },
    el: '#vue-news',
    filters: {
      format(date) {
        const objectDate = new Date(date);

        const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        };

        return objectDate.toLocaleDateString('fr-FR', options).replaceAll("/", ".");
      }
    },
    data() {
      return {
        isLoading: true,
        categories: [],
        filters: {
          page: 1,
          per_page: 6,
        },
        news: [],
        totalPages: null
      }
    },
    computed: {
      hasMore() {
        return this.totalPages > this.news.length;
      }
    },
    created() {
      this.getNews()
    },
    mounted() {
      window.addEventListener('hashchange', () => {
        this.getNews()
      }, false);
      this.getCategories()      
    },
    methods: {
      deleteEmptyCategories(cat) {
        return cat.filter((el) => el.count != 0 && el.slug != "faq" && el.count_origins != 0 )
      },
      getCategories() {
        axios.request({
          method: 'GET',
          url: `${baseUrl}/categories`,
          params: {
            per_page: 50,
          }
        }).then(response => {
          this.categories = this.deleteEmptyCategories(response.data)
        })
      },      
      getNews(more = false) {
        this.isLoading = true
        axios.request({
          method: 'GET',
          url: `${baseUrl}/posts`,
          data: this.form,
          headers: { 'content-type': 'application/json' },
          params: this.filters
        }).then(response => {
          this.news = (more)? this.news.concat(response.data) : response.data
          this.totalPages = response.headers['x-wp-total']
          this.isLoading = false
        }).catch((error) => {
          this.errors = Object.assign(this.errors, error.response.data)
        })
      },
      getMore() {
        this.filters.page++;
        this.getNews(true)
      },
      getCategory(category_id) {
        let category = this.categories.filter((obj) => obj.id === category_id)
        let categoryName = (category.length > 0)? category[0]['name'] : ''
        return categoryName
      },
      updateCategory(category) {
        this.news = []
        this.filters.per_page = 6
        this.filters.page = 1
        this.filters.categories = category
        this.getNews()
      }      
    }
  })
}
